"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Store_1 = require("./Store");
const SearchInput_1 = require("./Elements/SearchInput");
const SearchResultsInfo_1 = require("./Elements/SearchResultsInfo");
const mobx_react_1 = require("mobx-react");
const SearchPagination_1 = require("./Elements/SearchPagination");
const history_1 = require("history");
let SearchApp = class SearchApp extends React.Component {
    constructor(props) {
        super(props);
        Store_1.default.query = props.query;
        Store_1.default.previousQuery = props.query;
        Store_1.default.results = props.preloadedResults;
        Store_1.default.skip = props.skip;
        Store_1.default.take = props.take;
        Store_1.default.translations = props.translations;
        const history = (0, history_1.createBrowserHistory)();
        history.listen((location) => {
            Store_1.default.skip = location.state.skip;
            Store_1.default.query = location.state.query;
            Store_1.default.Search(false, true);
        });
    }
    render() {
        return React.createElement("article", { id: "main-content" },
            React.createElement("div", { className: "o-container" },
                React.createElement("div", { className: "row col-sx-12 off-md-1 col-md-10" },
                    React.createElement("div", { id: "search-results", className: "o-container" },
                        React.createElement(SearchInput_1.default, null),
                        React.createElement("div", null,
                            React.createElement("h2", { className: "s-h2" }, Store_1.default.previousQuery && Store_1.default.translations.searchResultsTitle)),
                        Store_1.default.previousQuery && React.createElement(SearchResultsInfo_1.default, null),
                        Store_1.default.results && React.createElement(SearchPagination_1.default, null),
                        React.createElement("div", { className: "results" },
                            Store_1.default.loading &&
                                React.createElement("div", { className: "ui active inverted dimmer" },
                                    React.createElement("div", { className: "ui text loader" }, Store_1.default.translations.loading)),
                            Store_1.default.results && Store_1.default.results.hits.map((item, index) => {
                                return (React.createElement("div", { key: index, className: "listResult" },
                                    React.createElement("h3", null,
                                        React.createElement("a", { className: "s-h3", href: item.url }, item.title)),
                                    item.hasHighlights === true ? React.createElement("p", { dangerouslySetInnerHTML: { __html: item.excerpt } }) : React.createElement("p", null, item.summary)));
                            })),
                        Store_1.default.results && React.createElement(SearchPagination_1.default, null)))));
    }
};
SearchApp = __decorate([
    mobx_react_1.observer
], SearchApp);
exports.default = SearchApp;
